<template>
  <div>
    <div id="mapwrapper">
      <div id="mapbase" :style="{ 'max-width': maxWidth + 'px' }">
        <!-- V4.1 -->
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 450 900"
          xml:space="preserve"
        >
          <g>
            <path
              id="usiljs1"
              fill="#ffffff"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M76.884,342.107l0.307-32.024l0.107-11.241l-60.37-0.302c-1.924,2.829-0.113,12.561,1.132,17.54c1.245,4.979,3.96,12.447,7.016,14.259c3.055,1.811,0.113,3.62-1.358,4.639s-1.697,3.055,0,6.224s5.997,4.074,7.695,5.998c1.697,1.924,0.226,3.168-0.679,4.865H76.79L76.884,342.107z"
            ></path>
            <path
              id="usiljs2"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M252.468,678.868c-0.622-0.396-0.904-0.736-2.206-0.566s-4.13-1.754-5.437-2.716c-1.307-0.961-0.052-1.132,0-2.828c0.051-1.697,0.685-2.037,0.164-3.904c-0.521-1.867,0.351-1.754,0.521-3.678c0.169-1.924-0.623-2.603-0.511-3.791c0.113-1.188,1.302-1.924,1.528-3.056c0.227-1.131,3.396-3.733,4.3-4.47c0.906-0.735,1.188-2.659-0.113-3.621c-1.301-0.962-1.584-2.15-1.584-2.15h-26.366c-2.263,0.68-1.584,1.133-2.603,3.282c-1.019,2.15-1.697,3.621,0,5.771c1.698,2.149,2.263,0.792,4.867,0.792c2.602,0,2.037,1.357,0.226,1.924s-0.793,3.621,0.679,7.469c1.472,3.847,5.997,8.373,7.355,9.505c1.357,1.132,0.792,3.733-0.78,4.75c-1.183,0.765-0.332,1.661,2.327,3.322c2.657,1.661,6.146,3.322,7.308,4.983c1.163,1.661,3.322,0.665,3.654-2.324c0.333-2.991-4.317-2.327-4.484-4.486c-0.165-2.159,2.658-2.658,4.152-2.491c1.496,0.166,2.825,3.322,4.984,5.481c2.159,2.16,1.33,2.326,1.496,4.818s2.491,1.328,5.647,0.995c3.155-0.332,0.165-2.325-2.99-4.152c-3.156-1.826-1.163-4.817-0.499-6.645C254.104,681.083,253.09,679.264,252.468,678.868z"
            ></path>
            <path
              id="usiljs3"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M245.962,476.2l-34.91-0.057v-14.994c0,0-0.678-0.622-1.98-0.622c-1.301,0-2.433-2.036-2.433-2.036v-13.24h5.262v-3.677h34.061V476.2z"
            ></path>
            <path
              id="usiljs4"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M301.811,41.479c0.409-3.132,0.438-13.61,0.289-16.332c-0.152-2.723-0.421-7.721-0.421-7.721l-23.683-0.136l-0.002,42.424h23.816c0,0-0.816-4.354,0-5.987C302.628,52.094,301.402,44.608,301.811,41.479z"
            ></path>
            <path
              id="usiljs5"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M110.511,337.919c0.566-1.696,2.942-3.168,4.074-4.639c1.131-1.472,0.679-3.734,2.829-5.319c2.15-1.583,0-3.847,0-3.847s-5.884,0.113-7.016,1.019c-1.131,0.905-2.603-0.905-2.716-2.603s0.792-3.169-1.697-3.282c-2.49-0.113-4.752-2.149-4.752-4.3c0-2.149-2.829-1.472-2.942-3.282c-0.113-1.81-1.358-1.47-2.829-1.696c-1.471-0.228-4.3-0.34-7.129-0.113s-11.141,0.227-11.141,0.227l-0.307,32.024l35.663,0.679C112.547,342.786,109.945,339.617,110.511,337.919z"
            ></path>
            <path
              id="usiljs6"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M206.733,171.84v10.967h18.106V171.84h10.711c0,0,1.887-0.604,1.435-3.999c-0.452-3.394-0.604-3.016,2.112-4.148c2.716-1.131,5.355-1.735,6.261-2.715c0.905-0.981,4.374,1.584,5.885,1.885c1.508,0.303,4.225-0.074,4.225-0.074v-33.42h-48.093H184.63v42.472H206.733z"
            ></path>
            <path
              id="usiljs7"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M120.695,449.155c-1.527,0.962-2.602,1.811-4.074,1.019c-1.471-0.793-5.262-5.771-5.036-7.639c0.227-1.867-1.357-3.678-1.357-5.318s-1.075-6.168-1.471-7.581c-0.396-1.415-2.207-4.471-0.792-5.771c1.415-1.302,2.829-4.074,1.753-6.507c-1.075-2.434-2.037-5.205-1.301-6.563c0.735-1.357-0.623-4.356-1.415-6.45c-0.792-2.093,0-7.864,0-7.864l-32.137,0.057c1.584,1.924,4.187,2.716,10.071,7.016c5.884,4.301,5.318,6.224,9.392,9.279s2.15,5.318,2.829,6.79c0.679,1.47,0.679,6.563,2.716,10.297c2.037,3.734,0.226,5.205-1.132,6.337c-1.358,1.131-0.339,3.509,0.792,5.885s2.15,4.979,2.15,6.902s1.245,6.11,5.206,9.393c3.96,3.28,5.997,3.508,7.242,2.149c1.245-1.358,5.771-6.11,6.902-7.129c1.132-1.019,0.227-3.168,2.038-4.3C123.072,449.155,122.223,448.193,120.695,449.155z"
            ></path>
            <path
              id="usiljs8"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M201.917,54.229h-23.408H136.99c3.848,1.358,3.961,2.717,8.487,3.848c4.526,1.132,4.187,2.037,3.847,4.64c-0.339,2.603,1.131,0.792,2.942,0.453c1.811-0.34,2.037,1.244,1.245,4.413s-0.679,4.3,1.245,7.355c1.924,3.055,1.471,2.828,0,5.885c-1.471,3.055-2.15,4.412-0.453,5.883h47.614V54.229z"
            ></path>
            <path
              id="usiljs9"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M170.372,309.856c0,0-3.109,1.244-3.535-0.905c-2.35,0.791-4.16,3.621-5.631,3.848c-1.471,0.226-5.092,0.565-6.45,1.245c-1.358,0.679-0.905,0.226-3.96,1.47c-3.055,1.245-7.469,0.566-9.053-0.565c-1.584-1.132-2.49-3.395-3.395-5.432c-0.905-2.037-4.074-1.811-4.074-1.811c-3.169-0.679-3.734,5.432-6.224,6.45c-2.489,1.019-0.792,6.224-2.829,6.224c-2.037,0-3.508,1.584-5.206,2.377c-1.697,0.791-2.603,1.357-2.603,1.357s2.15,2.264,0,3.847c-2.15,1.585-1.698,3.848-2.829,5.319c-1.131,1.471-3.508,2.942-4.074,4.639h59.861v-3.733V309.856z"
            ></path>
            <path
              id="usiljs10"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M327.097,274.324l53.298-0.038c0,0,0.755,3.621,0.68,5.357c-0.075,1.734,0.086,11.843,0.005,13.653c-0.08,1.811-1.59,2.716-1.59,2.716l0.807,41.643h-53.199v-49.073V274.324z"
            ></path>
            <path
              id="usiljs11"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M269.385,365.53l-11.993-0.452V348.67c0,0,0.112-2.149-2.037-2.829c-2.151-0.679-2.037-0.453-3.056-0.905c-1.02-0.452-1.924,0.905-1.924,0.905c-1.358,0.905-3.282-2.829-3.961-1.698c-0.679,1.133-1.018,1.245-2.941,2.49c-1.924,1.244-3.396,4.753-5.658,4.64c-2.264-0.113-3.848,1.472-6.337,2.376c-2.489,0.906-2.717-2.376-2.717-2.376v10.185h-5.431v5.318h-5.206l-0.565,14.598v21.273h39.718h12.107V365.53z"
            ></path>
            <path
              id="usiljs12"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M405.818,385.485l-27.989,0.452h-5.582v13.201l1.058,24.518h5.129c0,0,16.296-1.434,19.161-0.679c2.868,0.754,4.979,0.679,5.734,0.679c0.754,0,4.904-0.377,5.055,0.529c0.15,0.904,3.363,1.412,3.363,1.412c1.161-0.331,0-0.995-0.666-1.162c-0.664-0.166,0.5-1.66,1.993-2.325c1.496-0.665,1.496-2.16,3.322-2.658c1.829-0.497,1.164-3.487,0.998-4.816c-0.167-1.33-1.827,0.831-2.491-1.163c-0.665-1.993-1.829-3.654-0.499-4.484s-2.99-0.831-0.831-2.327c2.161-1.494,1.496-3.487,3.654-3.155c2.161,0.333,3.821-1.661,3.821-1.661v-15.282l-14.703-0.021L405.818,385.485z"
            ></path>
            <path
              id="usiljs13"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M337.281,455.604l-34.514,0.113v10.411V493.4h44.472c0,0-2.489-1.585-3.837-3.396s3.158-3.733,1.007-6.224c-2.149-2.489-0.226,0.453,0-3.301c0.228-3.754,2.83-2.696,2.83-2.696v-14.032l-9.958-0.489V455.604z"
            ></path>
            <path
              id="usiljs14"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M207.261,511.731c3.056-3.847,4.866-2.715,10.75-3.281c5.884-0.565,5.998,1.019,7.469-0.905s5.771,2.037,7.921-1.075c2.149-3.111,3.62-2.772,5.317-1.979c1.698,0.792,11.316,0.227,13.127,0.792c1.812,0.565,5.318,1.018,5.318,1.018v-29.308l-11.202-0.792l-34.91-0.057v10.807h-10.919v29.082v0.565c0,0,0,0,2.716-2.15C205.564,512.298,204.207,515.579,207.261,511.731z"
            ></path>
            <path
              id="usiljs15"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M367.721,361.344l9.808-0.227l0.301,24.82h-5.582v13.201l-46.509,0.227l-0.565-9.279v-25.008h41.982L367.721,361.344z"
            ></path>
            <path
              id="usiljs16"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M349.854,59.715v10.479h-3.131v9.936l35.521-0.816v33.616l-4.219,3.947h-7.623v5.444h12.86v10.215h11.692v10.336l27.091,0.002v-32.227c0,0-1.163-1.661-2.491-2.825c-1.329-1.162-2.16-4.318-3.156-6.146c-0.997-1.827-2.825-3.821-3.322-5.98c-0.498-2.159,0.996-3.488,0-4.816c-0.997-1.329-2.16-3.821-2.16-5.316s-0.666-4.32-1.495-6.312c-0.831-1.993-1.993-3.488-2.16-7.309c-0.166-3.821-4.816-5.417-8.803-12.229H353.8H349.854z"
            ></path>
            <path
              id="usiljs17"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M408.384,424.186c-0.15-0.906-4.301-0.529-5.055-0.529c-0.756,0-2.866,0.075-5.734-0.679c-2.865-0.755-19.161,0.679-19.161,0.679l1.056,39.606h3.697h38.361c-1.662-0.83-2.991-3.777-1.164-3.777c1.828,0,0.166-2.989,1.828-3.322c1.66-0.331,0.165-3.155,0.996-4.484s-1.827-3.322-4.816-4.816c-2.99-1.496-1.496-2.659-0.333-4.818c1.162-2.16-1.662-2.326-0.498-3.654c1.161-1.328-1.66-3.323-4.153-3.82c-2.491-0.498,0.332-2.492-1.993-3.157c-2.326-0.663-3.655,0.332-0.664-1.661c2.991-1.992,0,0-1.164-1.661c-1.163-1.661,0.997-2.159,2.161-2.492C411.747,425.598,408.534,425.09,408.384,424.186z"
            ></path>
            <path
              id="usiljs18"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M325.738,399.365l46.509-0.227l1.058,24.518h-36.023h-11.543v-4.828V399.365z"
            ></path>
            <path
              id="usiljs19"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M277.994,123.86h34.507v-11.693V70.752c0,0,0.604,0,1.885-1.434c1.283-1.434-0.753-5.432-0.598-6.64c0.158-1.206,0-2.964,0-2.964h-11.978h-23.816v32.084V123.86z"
            ></path>
            <path
              id="usiljs20"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M257.392,316.537V288.13h57.937l-11.882,16.182v6.45h-5.318v4.979L257.392,316.537z"
            ></path>
            <path
              id="usiljs21"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M327.097,337.655h53.199v10.562H377l0.528,12.9l-9.808,0.227l-0.565,3.734h-41.982V348.67l1.924-0.68V337.655z"
            ></path>
            <path
              id="usiljs22"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M346.723,112.167V80.13l35.521-0.816v33.616l-4.219,3.947h-7.623v-5.614L346.723,112.167z"
            ></path>
            <path
              id="usiljs23"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M418.039,338.334c1.585,0.756-0.831,0.83-2.489,0.981c-1.66,0.151-2.642-1.66-2.642-1.66h-32.612v10.562H377l0.528,12.9l0.301,24.82l27.989-0.452l0.527,1.056l14.703,0.021v-49.36l-3.538,0.077C417.511,337.279,416.455,337.58,418.039,338.334z"
            ></path>
            <path
              id="usiljs24"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M358.498,535.569h17.268c-0.355-0.575-0.802-1.386-0.802-1.828c0-0.735,2.376-2.263,3.394-2.659c1.02-0.396,0.906-1.357,0.34-3.168c-0.566-1.812,0.226-3.282-0.849-4.301c-1.075-1.018-1.472-1.754-1.472-3.847c0-2.094,2.094-4.356,3.169-5.998c1.075-1.641-0.736-4.809-1.019-6.619c-0.283-1.811,0.057-3.396,1.527-4.3c1.472-0.906-1.527-2.547-1.527-2.547V497.7h-20.029V535.569z"
            ></path>
            <path
              id="usiljs25"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M291.904,418.602l33.834,0.227v4.828h11.543v31.948l-34.514,0.113h-11.26L291.904,418.602z"
            ></path>
            <path
              id="usiljs26"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M258.183,466.129l-1.019,10.863l-11.202-0.792v-34.626v-22.973h11.315h34.627l-0.396,37.116h11.26v10.411H258.183z"
            ></path>
            <path
              id="usiljs27"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M349.086,247.506l-0.375-46.018l11.691-0.453l1.208,62.388h18.784v10.863l-53.298,0.038v-26.818H349.086z"
            ></path>
            <path
              id="usiljs28"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M302.768,578.1v-26.648h-44.924c0,0,0.227,3.055,0.792,3.281c0.565,0.226,2.149,1.471,1.132,3.395c-1.02,1.924-3.396,3.169-3.282,5.433c0.113,2.263,1.245,3.507,0,5.657s-2.094,3.564-2.094,3.564h2.094v10.92h46.282V578.1z"
            ></path>
            <path
              id="usiljs29"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M154.304,296.994c1.811-0.603,3.244-2.565,3.546-3.772s2.338-3.244,3.923-5.809c1.584-2.565,2.867-7.77,4.602-9.128c1.735-1.358,1.583-2.716,2.791-3.018c1.207-0.301,7.77-5.582,7.77-5.582s2.414-2.188,4.225-3.848c1.811-1.659,1.433-4.979,1.811-5.584c0.377-0.603,1.207-6.487,0.83-7.317c-0.377-0.83-0.83-6.411-0.83-6.411l-11.467-0.452v-10.035l-46.282-0.753v10.331l-0.991,42.965l-0.254,10.978c0,0,17.766,0.227,19.803,0c2.037-0.227,5.998,1.132,5.998,1.132S152.493,297.598,154.304,296.994z"
            ></path>
            <path
              id="usiljs30"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M363.194,579.344c-0.735-1.357-2.319-1.866-2.319-1.866s-19.067-0.453-20.256,0.227c-1.188,0.679-4.696,0.622-4.696,0.622v37.003h18.162c0,0,2.829,0.623,3.396,2.206c0.565,1.585,1.414,2.037,1.811,1.924c0.396-0.113,1.459-0.503,1.459-0.503c-0.666-2.325-2.991-7.475-2.824-9.967c0.166-2.492,0.664-6.811,5.646-7.973c4.984-1.163,6.146-5.482,7.31-8.639c1.162-3.156-2.158-1.328-4.485-1.163c-2.325,0.167-0.166-5.315,1.329-3.322c1.494,1.994,4.983,0.499,3.821-0.83c-1.137-1.299-4.797-3.785-6.479-6.563C365.068,580.499,363.93,580.702,363.194,579.344z"
            ></path>
            <path
              id="usiljs31"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M115.49,421.658c2.716,0.339,2.942,3.167,4.074,3.62s1.131-1.796,1.131-1.796h17.313v-6.125l11.542-0.227l0.792-4.188h4.526l-1.019-31.231h-14.258l-28.629-0.339c-0.905,5.885-3.395,7.469-3.734,10.185c-0.339,2.715-0.226,4.922-0.226,4.922s-0.792,5.771,0,7.864c0.792,2.094,2.15,5.093,1.415,6.45c-0.736,1.358,0.226,4.13,1.301,6.563c1.075,2.433-0.339,5.205-1.753,6.507c-1.415,1.301,0.396,4.356,0.792,5.771c0,0,1.528-2.999,2.546-5.149C112.321,422.336,112.774,421.318,115.49,421.658z"
            ></path>
            <path
              id="usiljs32"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M313.073,144.838l34.882-0.685l0.756,31.459c0,0,0.226,3.923,0.754,6.034c0.527,2.113-0.379,5.13-0.379,5.13l-34.851,0.528L313.073,144.838z"
            ></path>
            <path
              id="usiljs33"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M302.768,535.569h33.155v42.53h-33.155v-26.648V535.569z"
            ></path>
            <path
              id="usiljs34"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M77.396,288.581l0.411-42.965l-29.534-0.261c-5.545-2.829-16.748,4.413-19.803,7.016c-3.055,2.603-2.942,3.621-1.245,4.3c1.698,0.68,2.489,1.358,3.848,3.396c1.358,2.037,0.565,3.055-0.792,5.997c-1.358,2.942-0.227,5.771,0.905,7.016c1.131,1.245-0.113,2.717-2.037,3.056c-1.924,0.34-3.96,0-7.355,4.188c-3.395,4.187-2.942,15.39-4.866,18.218l60.37,0.302L77.396,288.581z"
            ></path>
            <path
              id="usiljs35"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M357.48,617.535c-0.566-1.583-3.396-2.206-3.396-2.206h-18.162h-3.621l-0.622,22.065c3.489,0,2.158,1.828,5.149,1.994c2.989,0.166,0.996-3.488,4.484-4.817c3.489-1.329,9.469-2.325,16.279-2.658s9.469-0.997,9.469-5.149s-5.647-5.481-6.312-7.808c0,0-1.063,0.39-1.459,0.503C358.895,619.572,358.046,619.12,357.48,617.535z"
            ></path>
            <path
              id="usiljs36"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M89.916,245.616v-53.785H73.508c0,2.263,0.792,4.866,0,7.695s-1.811,5.205-0.34,7.921c1.472,2.716-0.679,2.941-3.168,3.848c-2.489,0.904-8.939,8.261-10.75,10.523c-1.811,2.263,1.019,6.45-1.358,8.826c-2.376,2.377-1.019,6.451-0.679,7.921c0.339,1.472-4.074,6.111-8.939,6.79l29.534,0.261H89.916z"
            ></path>
            <path
              id="usiljs37"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M183.725,182.703V171.84h0.905v-42.472h-33.834c0,0,0.226,0.339,0.679,2.036c0.452,1.697-0.679,3.621-3.282,4.074c-2.602,0.452-7.242,1.471-9.844,2.489c-2.603,1.019-4.188,0.227-5.771,2.264c-1.584,2.036-4.074,4.752-6.676,5.432v14.371l-0.679,21.839l46.385,0.934L183.725,182.703z"
            ></path>
            <path
              id="usiljs38"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M360.402,201.035l61.644-1.85v63.955l-41.651,0.282H361.61L360.402,201.035z"
            ></path>
            <path
              id="usiljs39"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M222.764,620.195c1.697,0.904,1.811-0.057,2.604-1.245c0.792-1.188,1.244-3.621,1.244-3.621h29.874v-31.628v-10.92h-2.094h-43.169c0,0-0.227,2.093-1.245,3.338c-1.019,1.244-2.999,3.791-3.282,5.035c-0.283,1.245-1.188,4.641-1.923,5.771c-0.735,1.132-2.037,3.226-2.037,3.226c3.394,2.037,1.697,4.413,0.905,5.092c-0.792,0.68,0.226,2.263,1.584,2.829c1.357,0.565,3.168,0.679,5.092,2.603s7.92,2.716,9.392,4.526c1.471,1.811-0.227,1.697-0.566,4.413c-0.339,2.717,2.829,4.414,4.188,5.658c1.357,1.245-0.792,4.073-2.15,3.056C221.18,618.328,221.066,619.289,222.764,620.195z"
            ></path>
            <path
              id="usiljs40"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M337.281,423.656h36.023h5.129l1.056,39.606l-32.25,0.489l-9.958-0.489v-7.658V423.656z"
            ></path>
            <path
              id="usiljs41"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M257.164,509.13l45.604-0.68v27.119v15.882h-44.924h-1.358l0.679-10.751V509.13z"
            ></path>
            <path
              id="usiljs42"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M154.869,412.943h-4.526l-0.792,4.188l-11.542,0.227v6.125h-17.313c0,0,0,2.249-1.131,1.796s-1.358-3.281-4.074-3.62c-2.716-0.34-3.168,0.678-4.187,2.828c-1.018,2.15-2.546,5.149-2.546,5.149c0.396,1.413,1.471,5.94,1.471,7.581s1.584,3.451,1.357,5.318c-0.226,1.867,3.565,6.846,5.036,7.639c1.472,0.792,2.546-0.057,4.074-1.019c1.528-0.962,2.377,0,2.377,0c1.81-1.132,2.829-0.453,5.091-0.453c2.264,0,8.375,4.188,10.298,5.093c1.924,0.905,2.716,0.227,3.734,0.452v-8.996h13.239L154.869,412.943z"
            ></path>
            <path
              id="usiljs43"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M177.556,16.712l-72.623-0.418c0,0-0.873,1.386-1.099,2.631s-0.227,1.357,1.81,2.828c2.037,1.472,6.79,2.15,7.469,4.073c0.678,1.924,1.584,2.604,4.187,3.282s5.771,4.413,8.94,7.469c3.168,3.055,0.678,3.281,0.792,7.468c0.114,4.188,6.111,8.827,9.958,10.185h41.519L177.556,16.712z"
            ></path>
            <path
              id="usiljs44"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M267.783,623.986c-0.245,1.018-0.548,12.391,0,13.805c0.547,1.415-0.095,5.94-0.322,7.242c-0.226,1.302,0.68,3.452,0.68,3.452s-0.565,3.337-0.282,4.243c0.282,0.904,2.489-1.415,3.055-1.811c0.565-0.396,1.754,0,2.829,0.848c1.075,0.85,2.32,0.85,3.395,0.51c1.075-0.34,2.376-0.51,2.376-0.51s1.132-0.169,1.811-0.621c0.68-0.453,1.472-3.057,1.472-3.057h18.784v-32.759l-33.438,0.68C268.141,616.009,268.028,622.968,267.783,623.986z"
            ></path>
            <path
              id="usiljs45"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M313.788,62.679c-0.155,1.208,1.881,5.206,0.598,6.64c-1.281,1.434-1.885,1.434-1.885,1.434v41.415h34.222V80.13v-9.936h3.131V59.715h-36.065C313.788,59.715,313.946,61.473,313.788,62.679z"
            ></path>
            <path
              id="usiljs46"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M372.171,164.521h49.875v34.664l-61.644,1.85l-11.691,0.453l0.375-14.712c0,0,0.906-3.017,0.379-5.13c-0.528-2.111-0.754-6.034-0.754-6.034h23.46V164.521z"
            ></path>
            <path
              id="usiljs47"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M312.501,112.167h34.222l1.232,31.986l-34.882,0.685l-0.572-20.978V112.167z"
            ></path>
            <path
              id="usiljs48"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M125.222,235.285v-43.454v-9.958l46.385,0.934l-0.103,20.642v32.59L125.222,235.285z"
            ></path>
            <path
              id="usiljs49"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M353.8,26.1c-0.27,1.905,0.681,13.201,0,14.835c-0.679,1.633-0.544,6.94-0.544,8.029c0,1.09,0.544,10.751,0.544,10.751h44.658c-1.66-2.324-4.32-7.207-5.481-8.868c-1.163-1.661-2.493-8.306-2.327-9.967s1.828-8.141,2.992-9.302c1.163-1.164,0-6.645,0.995-7.476c0.997-0.831-0.995-6.146-0.995-6.146l-39.84-0.229C353.802,17.727,354.072,24.194,353.8,26.1z"
            ></path>
            <path
              id="usiljs50"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M255.468,187.909v-25.121v-33.42v-5.508h22.526h34.507l0.572,20.978l1.162,42.467h-35.382v22.632h-11.542v-22.027H255.468z"
            ></path>
            <path
              id="usiljs51"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M424.039,471.446c1.161-0.166,0.498-2.16-0.678-2.99c-1.174-0.83-0.153-4.363-1.813-5.193h-38.361V497.7h26.584c0.064-0.168,0.119-0.336,0.148-0.506c0.331-1.994,0.997-2.824,2.823-2.16c1.828,0.663,0.499-1.495-0.663-2.99c-1.163-1.494,0.829-2.824,1.993-5.149c1.162-2.326,3.155-2.325,6.811-3.321c3.652-0.997,2.491-5.814,3.763-6.479C425.915,476.429,422.875,471.613,424.039,471.446z"
            ></path>
            <path
              id="usiljs52"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M255.468,123.86h22.526V91.799h-42.669c0,0-1.245-1.584-3.056-1.472c-1.811,0.113-1.698,1.472-2.829,1.472c-1.132,0-0.226-0.905-2.263-2.489c-2.037-1.585-4.414,1.244-4.414,1.244h-15.389v38.814h48.093V123.86z"
            ></path>
            <path
              id="usiljs53"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M314.235,187.305l34.851-0.528l-0.375,14.712l0.375,46.018h-21.989h-11.882l-0.979-16.975h-35.345l-0.037-20.595v-22.632H314.235z"
            ></path>
            <path
              id="usiljs54"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M257.392,333.167l-7.017-0.227h-18.671l-1.472-2.036h-7.355l-0.227-5.53h-9.618v-13.48l-2.263-0.906v-3.289l-0.679-23.981l35.42-0.906v5.319h11.882v28.407V333.167z"
            ></path>
            <path
              id="usiljs55"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M297.393,354.327l-0.735-5.657l1.471-0.566V315.74l-40.736,0.797v16.63l-7.017-0.227v12.9c0,0,0.904-1.357,1.924-0.905c1.019,0.452,0.904,0.227,3.056,0.905c2.149,0.68,2.037,2.829,2.037,2.829v16.408l11.993,0.452h21.614v-11.203H297.393z"
            ></path>
            <path
              id="usiljs56"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M200.472,381.373l0.565,63.878h-45.603l-0.565-32.308l-1.019-31.231l23.876-0.339H200.472z"
            ></path>
            <path
              id="usiljs57"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M211.052,486.95v-10.807v-14.994c0,0-0.678-0.622-1.98-0.622c-1.301,0-2.433-2.036-2.433-2.036v-13.24h-5.601h-45.603h-13.239v8.996c1.018,0.227,1.923-0.452,3.395,0.679c1.471,1.132,10.977,6.224,13.239,8.487c2.263,2.263-0.226,1.358-0.34,3.848c-0.113,2.489-3.734,4.413-5.318,5.545c-1.583,1.131-1.583,3.055-4.187,5.092c-2.603,2.036,0.905,5.092,2.829,8.714l48.319,0.339H211.052z"
            ></path>
            <path
              id="usiljs58"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M302.768,466.129V493.4v15.05l-45.604,0.68v-2.83v-29.308l1.019-10.863H302.768z"
            ></path>
            <path
              id="usiljs59"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M226.951,203.448c0,0-1.056,4.678-3.093,6.488h43.453v-22.027h-11.844l-18.709,0.641c0,0-2.111-0.188,0-1.999c2.112-1.811,1.887-3.744,1.887-3.744H224.84h-18.106v20.642H226.951z"
            ></path>
            <path
              id="usiljs60"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M138.348,309.517c0.905,2.037,1.81,4.3,3.395,5.432c1.584,1.132,5.998,1.811,9.053,0.565c3.055-1.244,2.603-0.791,3.96-1.47c1.358-0.68,4.979-1.02,6.45-1.245c1.471-0.227,3.281-3.057,5.631-3.848c0.426,2.149,3.535,0.905,3.535,0.905l3.168-5.205c0,0,1.358,1.584,2.49,1.471c1.132-0.113,7.921,0.324,10.75,1.576c2.829,1.253,8.713,0.461,10.863-1.124c2.15-1.584,7.355-5.884,8.6-3.281c1.245,2.604,4.526,4.405,4.526,4.405l-0.679-23.981h-10.636l-0.339-14.031h-22.179c0,0-6.563,5.281-7.77,5.582c-1.208,0.302-1.056,1.659-2.791,3.018c-1.735,1.358-3.018,6.563-4.602,9.128c-1.584,2.564-3.621,4.602-3.923,5.809s-1.735,3.17-3.546,3.772c-1.811,0.604-4.527,3.696-4.527,3.696s1.132,3.169-1.358,3.621c-2.489,0.452-1.245,0.679-3.508,0c-2.263-0.68-3.508,1.585-5.998,1.697c-2.489,0.113-3.848,0.113-4.639,1.697C134.274,307.706,137.443,307.479,138.348,309.517z"
            ></path>
            <path
              id="usiljs61"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M322.627,669.306l-21.048-21.218h-18.784c0,0-0.792,2.604-1.472,3.057c-0.679,0.452-1.811,0.621-1.811,0.621l0.172,9.882c12.126,2.657,15.283,8.639,26.746,12.126c11.463,3.489,10.464,10.965,17.773,7.144c0,0-0.39-10.423-0.39-10.706S322.627,669.306,322.627,669.306z"
            ></path>
            <path
              id="usiljs62"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M124.23,288.581H77.396l0.411-42.965h12.108h35.306L124.23,288.581z"
            ></path>
            <path
              id="usiljs63"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M301.811,41.479c-0.408,3.129,0.817,10.614,0,12.248c-0.816,1.633,0,5.987,0,5.987h11.978h36.065h3.946c0,0-0.544-9.661-0.544-10.751c0-1.089-0.135-6.396,0.544-8.029c0.681-1.634-0.27-12.93,0-14.835c0.272-1.905,0.002-8.373,0.002-8.373l-52.123-0.3c0,0,0.269,4.998,0.421,7.721C302.249,27.869,302.22,38.348,301.811,41.479z"
            ></path>
            <path
              id="usiljs64"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M273.459,230.531h5.432h35.345l0.979,16.975h11.882v26.818v14.258l-11.769-0.452h-57.937H245.51v-5.319l-0.906-32.589h13.467v-2.603h3.395v-1.585l5.847-0.112v-4.301h6.147V230.531z"
            ></path>
            <path
              id="usiljs65"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M210.769,310.987v-3.289c0,0-3.281-1.802-4.526-4.405c-1.245-2.603-6.45,1.697-8.6,3.281c-2.15,1.585-8.034,2.377-10.863,1.124c-2.829-1.252-9.618-1.689-10.75-1.576c-1.131,0.113-2.49-1.471-2.49-1.471l-3.168,5.205v24.329l22.972,0.679l1.697-2.036h5.997v-7.454h11.995v-13.48L210.769,310.987z"
            ></path>
            <path
              id="usiljs66"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M125.222,191.831v-9.958l0.679-21.839H61.287c0.453,3.281-2.603,7.016-4.074,9.618s3.734,7.469,5.658,10.07c1.924,2.604,4.413-0.339,5.432,0.793c1.019,1.131,3.734,4.753,5.092,7.129s0.113,1.924,0.113,4.187h16.408H125.222z"
            ></path>
            <path
              id="usiljs67"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M166.751,539.456l13.522,0.792c0,0,0.226-3.396-0.849-4.018c-1.075-0.622-2.66-1.697-1.698-2.715c0.962-1.02,2.207-1.585,1.698-2.716c-0.509-1.132-0.509-1.132-0.509-1.132h-11.995l-11.543-13.184l-12.165-13.239c-1.697,3.961-1.81,5.658-1.924,8.261c-0.113,2.603-4.979,7.355-6.676,8.826c-1.698,1.471-0.905,5.432-2.15,6.563c-1.245,1.131,0.113,9.618,2.489,14.371s5.884,2.942,7.469,6.45c1.584,3.508,4.526,6.676,6.902,8.713l17.427-6.224V539.456z"
            ></path>
            <path
              id="usiljs68"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M211.901,445.251h-5.262h-5.601l-0.565-63.878h17.087v21.273h39.718v15.955h-11.315v22.973h-34.061V445.251z"
            ></path>
            <path
              id="usiljs69"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M178.632,376.507l-6.903-19.463l-1.358-19.125h-59.861c-0.565,1.698,2.037,4.867,2.037,4.867s-2.037,4.073-3.621,5.771l11.316-0.112l0.565,4.639h11.203v10.977h3.96v3.395h3.622v14.258h14.258l23.876-0.339L178.632,376.507z"
            ></path>
            <path
              id="usiljs70"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M298.128,348.104l27.045,0.566v16.408v25.008l-11.089,0.339v-3.394l-6.564-5.885h-6.902v-7.129h-9.618v-8.487v-11.203h6.394l-0.735-5.657L298.128,348.104z"
            ></path>
            <path
              id="usiljs71"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M227.178,89.31c2.037,1.584,1.131,2.489,2.263,2.489c1.131,0,1.019-1.358,2.829-1.472c1.811-0.112,3.056,1.472,3.056,1.472h42.669V59.715H254.45v-6.396h-23.408l-29.125,0.91v32.477h5.458v3.848h15.389C222.764,90.554,225.141,87.725,227.178,89.31z"
            ></path>
            <path
              id="usiljs72"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M182.971,246.525c0,0,0.453,5.581,0.83,6.411c0.377,0.83-0.453,6.715-0.83,7.317c0,0,2.64-1.433,4.979-2.489c2.339-1.055,4.375-2.489,6.563-2.263c2.188,0.227,4.601-1.961,6.337-1.056c1.735,0.905,2.188,0.301,4.526-0.83c2.339-1.132-1.358-3.243,0.604-5.432c1.961-2.188,3.018-3.093,3.394-5.13c0.377-2.037,3.924-4.148,6.187-5.885c2.263-1.734,0.753-5.355,0.753-5.355s0.076-1.584-0.905-2.641c-0.98-1.056-2.112-3.093,1.962-7.846s4.45-9.581,6.487-11.392s3.093-6.488,3.093-6.488h-20.218h-35.229v32.59v10.035L182.971,246.525z"
            ></path>
            <path
              id="usiljs73"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M256.485,563.56c-0.113-2.264,2.263-3.509,3.282-5.433c1.018-1.924-0.566-3.169-1.132-3.395c-0.565-0.227-0.792-3.281-0.792-3.281h-1.358l0.679-10.751l-45.942-0.452v32.533h43.169c0,0,0.849-1.414,2.094-3.564S256.599,565.822,256.485,563.56z"
            ></path>
            <path
              id="usiljs74"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M315.328,288.13l11.769,0.452v49.073v10.335l-1.924,0.68l-27.045-0.566V315.74v-4.979h5.318v-6.45L315.328,288.13z"
            ></path>
            <path
              id="usiljs75"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M107.229,391.558c0.339-2.716,2.829-4.3,3.734-10.185c1.923-4.64-1.245-9.054-2.376-12.222s-3.621-6.336-4.074-9.731c-0.452-3.396,2.845-6.571,4.414-10.863c1.584-1.697,3.621-5.771,3.621-5.771l-35.663-0.679l-0.095,9.957H30.733c-0.905,1.697-0.905,3.395,1.132,4.979c2.037,1.584,6.79,4.979,10.75,9.278s4.753,2.942,7.242,4.527c2.49,1.583,0,3.96,2.264,6.337c2.263,2.376,5.092-0.227,6.902,2.941c1.811,3.169,2.15,6.676,5.432,9.506c3.282,2.828,8.826,4.979,10.411,6.902l32.137-0.057C107.003,396.479,106.89,394.272,107.229,391.558z"
            ></path>
            <path
              id="usiljs76"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M301.579,615.329v32.759l21.048,21.218c0,0,1.188,0.622,1.188,0.905s0.39,10.706,0.39,10.706c8.584-4.487,6.812-12.957,2.658-18.105c-4.153-5.15-5.814-7.643-4.984-9.637c0.831-1.992,2.991-7.308,2.824-9.966c-0.166-2.656,3.489-5.814,6.978-5.814l0.622-22.065H301.579z"
            ></path>
            <path
              id="usiljs77"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M279.513,651.766c0,0-1.301,0.17-2.376,0.51c-1.074,0.34-2.319,0.34-3.395-0.51c-1.075-0.848-2.264-1.244-2.829-0.848c-0.565,0.396-2.772,2.715-3.055,1.811c-0.283-0.906,0.282-4.243,0.282-4.243l-19.011-0.397c0,0,0.283,1.188,1.584,2.15c1.302,0.962,1.02,2.886,0.113,3.621c-0.904,0.736-4.073,3.339-4.3,4.47c-0.227,1.132-1.415,1.867-1.528,3.056c-0.112,1.188,0.68,1.867,0.511,3.791c-0.17,1.924-1.042,1.811-0.521,3.678c0.521,1.867-0.113,2.207-0.164,3.904c-0.052,1.696-1.307,1.867,0,2.828c1.307,0.962,4.135,2.886,5.437,2.716s1.584,0.17,2.206,0.566c0.622,0.396,1.636,2.215,1.636,2.215c0.665-1.826,5.98-5.813,7.643-8.804c1.66-2.99,5.813-13.29,17.938-10.632L279.513,651.766z"
            ></path>
            <path
              id="usiljs78"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M236.759,186.551c-2.111,1.811,0,1.999,0,1.999l18.709-0.641v-25.121c0,0-2.717,0.377-4.225,0.074c-1.511-0.301-4.979-2.866-5.885-1.885c-0.905,0.979-3.545,1.584-6.261,2.715c-2.716,1.133-2.564,0.755-2.112,4.148c0.452,3.396-1.435,3.999-1.435,3.999H224.84v10.967h13.806C238.646,182.807,238.871,184.74,236.759,186.551z"
            ></path>
            <path
              id="usiljs79"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M206.695,581.154c0.283-1.244,2.263-3.791,3.282-5.035c1.019-1.245,1.245-3.338,1.245-3.338v-32.533h-11.089h-19.859l-13.522-0.792v10.75l-17.427,6.224c2.376,2.037,7.921,2.489,8.487,3.848c0.565,1.358,1.131,4.073,4.3,4.639c3.168,0.566,4.187,3.057,7.016,5.658c2.829,2.603,5.092-0.791,6.45,0.68s-0.453,2.489-2.263,4.188c-1.811,1.696,4.413,7.58,6.563,7.58c2.15,0,4.752-4.979,6.224-5.317c1.471-0.341,2.489,2.828,4.074,4.413c1.584,1.584,3.168,1.697,4.866,2.376s4.3,3.621,7.695,5.658c0,0,1.301-2.094,2.037-3.226C205.508,585.795,206.413,582.399,206.695,581.154z"
            ></path>
            <path
              id="usiljs80"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M347.239,463.752v14.032c0,0-2.603-1.058-2.83,2.696c-0.226,3.754-2.149,0.812,0,3.301c2.151,2.49-2.354,4.413-1.007,6.224s3.837,3.396,3.837,3.396h11.259v4.3h20.029h4.659v-34.438h-3.697L347.239,463.752z"
            ></path>
            <path
              id="usiljs81"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M125.9,145.663c2.603-0.68,5.092-3.396,6.676-5.432c1.584-2.037,3.168-1.245,5.771-2.264c2.603-1.019,7.242-2.037,9.844-2.489c2.603-0.453,3.734-2.377,3.282-4.074c-0.453-1.697-0.679-2.036-0.679-2.036s1.358-0.566,1.924-1.924c0.565-1.358,2.715-3.508,0.565-5.093c-2.15-1.584-4.413-1.472-5.998-3.961c-1.584-2.489-1.471-2.263-1.81-3.734c-0.34-1.47,0.565-3.507,0-4.695c-0.566-1.188-0.566-5.036-0.566-5.036c-3.96,2.037-7.468,5.771-7.242,7.582s0.453,3.282-1.245,4.866c-1.698,1.584-1.584,7.016-1.019,8.939c0.565,1.924-1.245,3.734-4.187,3.848c-2.942,0.112-5.884,4.413-7.808,6.449c-1.924,2.037-5.545,0-8.374,0c-2.829,0-6.676,1.924-9.619,5.885c-2.942,3.961-11.203,3.734-14.937,2.941c-3.734-0.792-8.374-0.792-10.75,1.924c-2.376,2.717-5.658,1.358-9.166,0.793c-3.508-0.566-7.242,1.244-7.242,3.961c0,2.715-2.49,4.639-2.037,7.921H125.9V145.663z"
            ></path>
            <path
              id="usiljs82"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M302.768,578.1h33.155v0.227v37.003h-3.621h-30.723l1.188-31.628V578.1z"
            ></path>
            <path
              id="usiljs83"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M223.33,366.775v-5.318h5.431v-10.185c0,0,0.228,3.282,2.717,2.376c2.489-0.904,4.073-2.489,6.337-2.376c2.263,0.113,3.734-3.396,5.658-4.64c1.924-1.245,2.263-1.357,2.941-2.49c0.679-1.131,2.603,2.604,3.961,1.698v-12.9h-18.671l-1.472-2.036h-7.355l-0.227-5.53h-9.618h-11.995v7.454h-5.997l-1.697,2.036l-22.972-0.679v3.733l1.358,19.125l6.903,19.463l-0.905,4.866h22.745h17.087l0.565-14.598H223.33z"
            ></path>
            <path
              id="usiljs84"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M95.46,309.97c1.471,0.227,2.716-0.113,2.829,1.696c0.113,1.811,2.942,1.133,2.942,3.282c0,2.15,2.263,4.187,4.752,4.3c2.489,0.113,1.584,1.585,1.697,3.282s1.584,3.508,2.716,2.603c1.132-0.905,7.016-1.019,7.016-1.019s0.905-0.566,2.603-1.357c1.697-0.793,3.168-2.377,5.206-2.377c2.037,0,0.339-5.205,2.829-6.224c2.49-1.019,3.055-7.129,6.224-6.45c0.792-1.584,2.15-1.584,4.639-1.697c2.49-0.112,3.734-2.377,5.998-1.697c2.263,0.679,1.019,0.452,3.508,0c2.49-0.452,1.358-3.621,1.358-3.621s-3.96-1.358-5.998-1.132c-2.037,0.227-19.803,0-19.803,0l0.254-10.978H77.396l-0.098,10.261l-0.107,11.241c0,0,8.312,0,11.141-0.227S93.99,309.742,95.46,309.97z"
            ></path>
            <path
              id="usiljs85"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M135.971,367.454v-3.395h-3.96v-10.977h-11.203l-0.565-4.639l-11.316,0.112c-1.568,4.292-4.866,7.468-4.414,10.863c0.453,3.396,2.942,6.563,4.074,9.731s4.3,7.582,2.376,12.222l28.629,0.339v-14.258H135.971z"
            ></path>
            <path
              id="usiljs86"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M291.904,418.602h-34.627v-15.955h12.107V365.53h21.614v8.487h9.618v7.129h6.902l6.564,5.885v3.394l11.089-0.339l0.565,9.279v19.463L291.904,418.602z"
            ></path>
            <path
              id="usiljs87"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M166.921,529.668h11.995c0,0,0,0,0.509,1.132c0.509,1.131-0.736,1.696-1.698,2.716c-0.962,1.018,0.623,2.093,1.698,2.715c1.075,0.622,0.849,4.018,0.849,4.018h19.859v-23.65v-0.565V486.95l-48.319-0.339c1.924,3.621-0.453,6.676-2.942,8.486c-2.49,1.811-3.96,4.187-5.658,8.147l12.165,13.239L166.921,529.668z"
            ></path>
            <path
              id="usiljs88"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M206.733,203.448h-35.229l0.103-20.642l12.118-0.104V171.84h0.905h22.104v10.967V203.448z"
            ></path>
            <path
              id="usiljs89"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M178.509,54.229l-0.953-37.518l53.35,0.307l0.136,36.301l-29.125,0.91H178.509z"
            ></path>
            <path
              id="usiljs90"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M244.604,250.222v-2.603h-6.563v-15.805h-21.727c0,0,1.509,3.621-0.753,5.355c-2.263,1.736-5.81,3.848-6.187,5.885c-0.376,2.037-1.433,2.941-3.394,5.13c-1.961,2.188,1.736,4.3-0.604,5.432c-2.339,1.131-2.791,1.735-4.526,0.83c-1.736-0.905-4.148,1.282-6.337,1.056c-2.188-0.227-4.224,1.208-6.563,2.263c-2.339,1.057-4.979,2.489-4.979,2.489c-0.378,0.604,0,3.925-1.811,5.584c-1.811,1.659-4.225,3.848-4.225,3.848h22.179l0.339,14.031h10.636l35.42-0.906L244.604,250.222z"
            ></path>
            <path
              id="usiljs91"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M268.141,648.485c0,0-0.905-2.15-0.68-3.452c0.228-1.302,0.869-5.827,0.322-7.242c-0.548-1.414-0.245-12.787,0-13.805c0.245-1.019,0.357-7.978,0.357-7.978l-11.655-0.68h-29.874c0,0-0.452,2.433-1.244,3.621c-0.793,1.188-0.906,2.149-2.604,1.245c-1.697-0.906-1.584-1.867-1.584-1.867c-1.358-1.019-3.055,0.679-2.376,3.507c0.679,2.83,4.073,8.602,7.808,14.146c3.734,5.545,2.716,5.884,2.037,9.053c-0.679,3.168-3.621,2.376-5.885,3.055h26.366L268.141,648.485z"
            ></path>
            <path
              id="usiljs92"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M380.395,274.286c0,0,0.755,3.621,0.68,5.357c-0.075,1.734,0.086,11.843,0.005,13.653c-0.08,1.811-1.59,2.716-1.59,2.716l0.807,41.643h32.612c0,0,0.981,1.812,2.642,1.66c1.658-0.151,4.074-0.226,2.489-0.981c-1.584-0.754-0.528-1.055-0.528-1.055l3.538-0.077v-0.309l0.997-73.753l-41.651,0.282V274.286z"
            ></path>
            <path
              id="usiljs93"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M378.527,497.7v2.603c0,0,2.999,1.641,1.527,2.547c-1.471,0.904-1.811,2.489-1.527,4.3c0.282,1.811,2.094,4.979,1.019,6.619c-1.075,1.642-3.169,3.904-3.169,5.998c0,2.093,0.396,2.829,1.472,3.847c1.074,1.019,0.282,2.489,0.849,4.301c0.566,1.811,0.68,2.771-0.34,3.168c-1.018,0.396-3.394,1.924-3.394,2.659c0,0.442,0.446,1.253,0.802,1.828c0.237,0.383,0.432,0.66,0.432,0.66s0.831,1.828,1.994,0.998c1.162-0.83,1.328-2.16,0.995-3.038c-0.331-0.879,0.333-3.773,2.66-3.44c2.324,0.333,0.331,1.495-0.167,2.497c-0.498,1.001,1.66,1.489,2.824,0c1.161-1.49,1.66-5.322,2.491-4.656c0.831,0.664,0.831,4.816,2.325,4.65c1.495-0.166,1.662-2.158,1.495-5.316c-0.164-3.156,1.33-5.813,3.987-5.813s3.322-2.989,4.319-4.65c0.998-1.661,0.497-3.322,1.827-3.987c1.327-0.664,0-1.994-1.662-1.994c-1.66,0,0.831-2.989,2.493-2.989c1.66,0,2.491-0.499,3.654-1.163c1.164-0.663,0.497-1.993,3.155-1.826c2.658,0.165,0.83-2.492-0.664-3.489c-1.366-0.911,1.149-2.518,1.845-4.311h-26.584H378.527z"
            ></path>
            <path
              id="usiljs94"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M125.222,245.616H89.916v-53.785h35.306v43.454V245.616z"
            ></path>
            <path
              id="usiljs95"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M257.164,509.13v-2.83c0,0-3.507-0.452-5.318-1.018c-1.811-0.565-11.429,0-13.127-0.792c-1.697-0.793-3.168-1.132-5.317,1.979c-2.15,3.112-6.45-0.849-7.921,1.075s-1.584,0.34-7.469,0.905c-5.884,0.566-7.694-0.565-10.75,3.281c-3.055,3.848-1.697,0.566-4.413,2.716c-2.716,2.15-2.716,2.15-2.716,2.15v23.65h11.089l45.942,0.452V509.13z"
            ></path>
            <path
              id="usiljs96"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M358.498,497.7v37.869h-22.575h-33.155V508.45V493.4h44.472h11.259V497.7z"
            ></path>
            <path
              id="usiljs97"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M380.517,546.363c-1.328-0.167-2.99-2.325-4.319-3.986c-1.33-1.661,0-6.147,0-6.147s-0.194-0.277-0.432-0.66h-17.268h-22.575v42.53v0.227c0,0,3.508,0.057,4.696-0.622c1.188-0.68,20.256-0.227,20.256-0.227s1.584,0.509,2.319,1.866c0.735,1.358,1.874,1.155,1.874,1.155c-1.662-2.743,0.996-2.075,2.657-1.244s5.149,2.326,5.315,0c0.166-2.325-3.654-1.163-5.647-1.993c-1.994-0.831,0-3.654,1.33-1.993c1.329,1.661,2.491-0.167,1.826-2.658c-0.663-2.491,4.153-2.492,1.662-4.153s-1.33-2.657,0.33-3.819c1.662-1.163,0.998-1.994-1.493-1.828c-2.493,0.167-1.829-2.823,0.332-2.823c2.159,0,7.31-0.166,7.31-3.281s-2.161-1.371-4.818-0.207c-2.657,1.163-2.491-2.991,0-2.492c2.493,0.498,2.159-3.488,4.485-3.156c2.325,0.332,1.66-0.5,3.156-1.828C383.008,547.692,381.847,546.529,380.517,546.363z"
            ></path>
            <path
              id="usiljs98"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M145.477,114.656c0.339,1.472,0.226,1.245,1.81,3.734c1.584,2.489,3.848,2.377,5.998,3.961c2.15,1.585,0,3.734-0.565,5.093c-0.566,1.357-1.924,1.924-1.924,1.924h33.834h22.745V90.554v-3.848h-5.458h-47.614c1.697,1.472,0.566,2.942-0.905,5.998s-2.376,6.563-1.923,8.374c0.452,1.81-2.603,1.81-6.563,3.847c0,0,0,3.848,0.566,5.036C146.042,111.149,145.137,113.187,145.477,114.656z"
            ></path>
            <path
              id="usiljs99"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M394.955,142.872l27.091,0.002v21.647h-49.875v11.091h-23.46l-0.756-31.459l-1.232-31.986l23.68-0.904v5.614v5.444h12.86v10.215h11.692V142.872z"
            ></path>
            <path
              id="usiljs100"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M302.768,583.701l-1.188,31.628l-33.438,0.68l-11.655-0.68v-31.628H302.768z"
            ></path>
            <path
              id="usiljs101"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M277.996,17.291l-0.002,42.424H254.45v-6.396h-23.408l-0.136-36.301L277.996,17.291z"
            ></path>
            <path
              id="usiljs102"
              fill="#FFFFFF"
              stroke="#AAAAAA"
              vector-effect="non-scaling-stroke"
              d="M223.858,209.937c-2.037,1.811-2.413,6.639-6.487,11.392s-2.942,6.79-1.962,7.846c0.98,1.057,0.905,2.641,0.905,2.641h21.727v15.805h6.563v2.603h13.467v-2.603h3.395v-1.585l5.847-0.112v-4.301h6.147v-11.09h5.432l-0.037-20.595h-11.542H223.858z"
            ></path>
          </g>
          <g id="visnames">
            <text
              id="usiljsvn1"
              transform="matrix(1 0 0 1 28 327)"
              font-size="14"
            >
              Adams
            </text>
            <text
              id="usiljsvn2"
              transform="matrix(1 0 0 1 205 656)"
              font-size="8"
            >
              Alexander
            </text>
            <text
              id="usiljsvn3"
              transform="matrix(1 0 0 1 215 459)"
              font-size="11"
            >
              Bond
            </text>
            <text
              id="usiljsvn4"
              transform="matrix(1 0 0 1 271 47)"
              font-size="12"
            >
              Boone
            </text>
            <text
              id="usiljsvn5"
              transform="matrix(1 0 0 1 82 334)"
              font-size="8"
            >
              Brown
            </text>
            <text
              id="usiljsvn6"
              transform="matrix(1 0 0 1 198 153)"
              font-size="12"
            >
              Bureau
            </text>
            <text
              id="usiljsvn7"
              transform="matrix(1 0 0 1 73 406)"
              font-size="8"
            >
              Calhoun
            </text>
            <text
              id="usiljsvn8"
              transform="matrix(1 0 0 1 161 74)"
              font-size="11"
            >
              Carroll
            </text>
            <text
              id="usiljsvn9"
              transform="matrix(1 0 0 1 133 330)"
              font-size="10"
            >
              Cass
            </text>
            <text
              id="usiljsvn10"
              transform="matrix(1 0 0 1 317 304)"
              font-size="14"
            >
              Champaign
            </text>
            <text
              id="usiljsvn11"
              transform="matrix(1 0 0 1 219 381)"
              font-size="12"
            >
              Christian
            </text>
            <text
              id="usiljsvn12"
              transform="matrix(1 0 0 1 379 407)"
              font-size="11"
            >
              Clark
            </text>
            <text
              id="usiljsvn13"
              transform="matrix(1 0 0 1 314 477)"
              font-size="10"
            >
              Clay
            </text>
            <text
              id="usiljsvn14"
              transform="matrix(1 0 0 1 211 497)"
              font-size="12"
            >
              Clinton
            </text>
            <text
              id="usiljsvn15"
              transform="matrix(1 0 0 1 333 385)"
              font-size="12"
            >
              Coles
            </text>
            <text
              id="usiljsvn16"
              transform="matrix(1 0 0 1 383 121)"
              font-size="15"
            >
              Cook
            </text>
            <text
              id="usiljsvn17"
              transform="matrix(1 0 0 1 380 456)"
              font-size="10"
            >
              Crawford
            </text>
            <text
              id="usiljsvn18"
              transform="matrix(1 0 0 1 327 412)"
              font-size="8"
            >
              Cumberland
            </text>
            <text
              id="usiljsvn19"
              transform="matrix(1 0 0 1 274 106)"
              font-size="13"
            >
              DeKalb
            </text>
            <text
              id="usiljsvn20"
              transform="matrix(1 0 0 1 263 305)"
              font-size="11"
            >
              DeWitt
            </text>
            <text
              id="usiljsvn21"
              transform="matrix(1 0 0 1 331 354)"
              font-size="11"
            >
              Douglas
            </text>
            <text
              id="usiljsvn22"
              transform="matrix(1 0 0 1 341 99)"
              font-size="14"
            >
              DuPage
            </text>
            <text
              id="usiljsvn23"
              transform="matrix(1 0 0 1 384 368)"
              font-size="11"
            >
              Edgar
            </text>
            <text
              id="usiljsvn24"
              transform="matrix(1 0 0 1 354 516)"
              font-size="7"
            >
              Edwards
            </text>
            <text
              id="usiljsvn25"
              transform="matrix(1 0 0 1 287 437)"
              font-size="12"
            >
              Effingham
            </text>
            <text
              id="usiljsvn26"
              transform="matrix(1 0 0 1 250 449)"
              font-size="11"
            >
              Fayette
            </text>
            <text
              id="usiljsvn27"
              transform="matrix(1 0 0 1 333 266)"
              font-size="11"
            >
              Ford
            </text>
            <text
              id="usiljsvn28"
              transform="matrix(1 0 0 1 258 573)"
              font-size="12"
            >
              Franklin
            </text>
            <text
              id="usiljsvn29"
              transform="matrix(1 0 0 1 135 264)"
              font-size="12"
            >
              Fulton
            </text>
            <text
              id="usiljsvn30"
              transform="matrix(1 0 0 1 337 598)"
              font-size="8"
            >
              Gallatin
            </text>
            <text
              id="usiljsvn31"
              transform="matrix(1 0 0 1 113 403)"
              font-size="10"
            >
              Greene
            </text>
            <text
              id="usiljsvn32"
              transform="matrix(1 0 0 1 309 169)"
              font-size="12"
            >
              Grundy
            </text>
            <text
              id="usiljsvn33"
              transform="matrix(1 0 0 1 303 561)"
              font-size="8"
            >
              Hamilton
            </text>
            <text
              id="usiljsvn34"
              transform="matrix(1 0 0 1 28 288)"
              font-size="11"
            >
              Hancock
            </text>
            <text
              id="usiljsvn35"
              transform="matrix(1 0 0 1 335 627)"
              font-size="9"
            >
              Hardin
            </text>
            <text
              id="usiljsvn36"
              transform="matrix(1 0 0 1 42 230)"
              font-size="9"
            >
              Henderson
            </text>
            <text
              id="usiljsvn37"
              transform="matrix(1 0 0 1 138 161)"
              font-size="12"
            >
              Henry
            </text>
            <text
              id="usiljsvn38"
              transform="matrix(1 0 0 1 369 233)"
              font-size="12"
            >
              Iroquois
            </text>
            <text
              id="usiljsvn39"
              transform="matrix(1 0 0 1 206 590)"
              font-size="13"
            >
              Jackson
            </text>
            <text
              id="usiljsvn40"
              transform="matrix(1 0 0 1 342 446)"
              font-size="10"
            >
              Jasper
            </text>
            <text
              id="usiljsvn41"
              transform="matrix(1 0 0 1 256 532)"
              font-size="11"
            >
              Jefferson
            </text>
            <text
              id="usiljsvn42"
              transform="matrix(1 0 0 1 116 437)"
              font-size="12"
            >
              Jersey
            </text>
            <text
              id="usiljsvn43"
              transform="matrix(1 0 0 1 117 28)"
              font-size="12"
            >
              Jo Daviess
            </text>
            <text
              id="usiljsvn44"
              transform="matrix(1 0 0 1 266 636)"
              font-size="9"
            >
              Johnson
            </text>
            <text
              id="usiljsvn45"
              transform="matrix(1 0 0 1 312 82)"
              font-size="15"
            >
              Kane
            </text>
            <text
              id="usiljsvn46"
              transform="matrix(1 0 0 1 355 190)"
              font-size="14"
            >
              Kankakee
            </text>
            <text
              id="usiljsvn47"
              transform="matrix(1 0 0 1 307 136)"
              font-size="13"
            >
              Kendall
            </text>
            <text
              id="usiljsvn48"
              transform="matrix(1 0 0 1 135 212)"
              font-size="12"
            >
              Knox
            </text>
            <text
              id="usiljsvn49"
              transform="matrix(1 0 0 1 355 50)"
              font-size="15"
            >
              Lake
            </text>
            <text
              id="usiljsvn50"
              transform="matrix(1 0 0 1 261 157)"
              font-size="14"
            >
              LaSalle
            </text>
            <text
              id="usiljsvn51"
              transform="matrix(1 0 0 1 384 478)"
              font-size="9"
            >
              Lawrence
            </text>
            <text
              id="usiljsvn52"
              transform="matrix(1 0 0 1 230 112)"
              font-size="12"
            >
              Lee
            </text>
            <text
              id="usiljsvn53"
              transform="matrix(1 0 0 1 285 213)"
              font-size="12"
            >
              Livingston
            </text>
            <text
              id="usiljsvn54"
              transform="matrix(1 0 0 1 218 308)"
              font-size="12"
            >
              Logan
            </text>
            <text
              id="usiljsvn55"
              transform="matrix(1 0 0 1 256 344)"
              font-size="13"
            >
              Macon
            </text>
            <text
              id="usiljsvn56"
              transform="matrix(1 0 0 1 150 426)"
              font-size="12"
            >
              Macoupin
            </text>
            <text
              id="usiljsvn57"
              transform="matrix(1 0 0 1 156 482)"
              font-size="14"
            >
              Madison
            </text>
            <text
              id="usiljsvn58"
              transform="matrix(1 0 0 1 261 490)"
              font-size="12"
            >
              Marion
            </text>
            <text
              id="usiljsvn59"
              transform="matrix(1 0 0 1 218 199)"
              font-size="9"
            >
              Marshall
            </text>
            <text
              id="usiljsvn60"
              transform="matrix(1 0 0 1 166 295)"
              font-size="11"
            >
              Mason
            </text>
            <text
              id="usiljsvn61"
              transform="matrix(1 0 0 1 283 662)"
              font-size="9"
            >
              Massac
            </text>
            <text
              id="usiljsvn62"
              transform="matrix(1 0 0 1 68 271)"
              font-size="12"
            >
              McDonough
            </text>
            <text
              id="usiljsvn63"
              transform="matrix(1 0 0 1 297 32)"
              font-size="15"
            >
              McHenry
            </text>
            <text
              id="usiljsvn64"
              transform="matrix(1 0 0 1 261 268)"
              font-size="14"
            >
              McLean
            </text>
            <text
              id="usiljsvn65"
              transform="matrix(1 0 0 1 175 319)"
              font-size="9"
            >
              Menard
            </text>
            <text
              id="usiljsvn66"
              transform="matrix(1 0 0 1 76 179)"
              font-size="11"
            >
              Mercer
            </text>
            <text
              id="usiljsvn67"
              transform="matrix(1 0 0 1 135 538)"
              font-size="12"
            >
              Monroe
            </text>
            <text
              id="usiljsvn68"
              transform="matrix(1 0 0 1 194 413)"
              font-size="12"
            >
              Montgomery
            </text>
            <text
              id="usiljsvn69"
              transform="matrix(1 0 0 1 125 350)"
              font-size="12"
            >
              Morgan
            </text>
            <text
              id="usiljsvn70"
              transform="matrix(1 0 0 1 292 368)"
              font-size="9"
            >
              Moultrie
            </text>
            <text
              id="usiljsvn71"
              transform="matrix(1 0 0 1 226 77)"
              font-size="12"
            >
              Ogle
            </text>
            <text
              id="usiljsvn72"
              transform="matrix(1 0 0 1 174 220)"
              font-size="14"
            >
              Peoria
            </text>
            <text
              id="usiljsvn73"
              transform="matrix(1 0 0 1 220 560)"
              font-size="11"
            >
              Perry
            </text>
            <text
              id="usiljsvn74"
              transform="matrix(1 0 0 1 300 330)"
              font-size="11"
            >
              Piatt
            </text>
            <text
              id="usiljsvn75"
              transform="matrix(1 0 0 1 68 375)"
              font-size="11"
            >
              Pike
            </text>
            <text
              id="usiljsvn76"
              transform="matrix(1 0 0 1 307 635)"
              font-size="8"
            >
              Pope
            </text>
            <text
              id="usiljsvn77"
              transform="matrix(1 0 0 1 251 659)"
              font-size="7"
            >
              Pulaski
            </text>
            <text
              id="usiljsvn78"
              transform="matrix(1 0 0 1 228 180)"
              font-size="7"
            >
              Putnam
            </text>
            <text
              id="usiljsvn79"
              transform="matrix(1 0 0 1 158 564)"
              font-size="12"
            >
              Randolph
            </text>
            <text
              id="usiljsvn80"
              transform="matrix(1 0 0 1 345 487)"
              font-size="9"
            >
              Richland
            </text>
            <text
              id="usiljsvn81"
              transform="matrix(1 0 0 1 51 134)"
              font-size="14"
            >
              Rock Island
            </text>
            <text
              id="usiljsvn82"
              transform="matrix(1 0 0 1 303 594)"
              font-size="11"
            >
              Saline
            </text>
            <text
              id="usiljsvn83"
              transform="matrix(1 0 0 1 173 346)"
              font-size="14"
            >
              Sangamon
            </text>
            <text
              id="usiljsvn84"
              transform="matrix(1 0 0 1 83 303)"
              font-size="9"
            >
              Schuyler
            </text>
            <text
              id="usiljsvn85"
              transform="matrix(1 0 0 1 114 373)"
              font-size="8"
            >
              Scott
            </text>
            <text
              id="usiljsvn86"
              transform="matrix(1 0 0 1 276 402)"
              font-size="12"
            >
              Shelby
            </text>
            <text
              id="usiljsvn87"
              transform="matrix(1 0 0 1 148 508)"
              font-size="14"
            >
              St. Clair
            </text>
            <text
              id="usiljsvn88"
              transform="matrix(1 0 0 1 180 194)"
              font-size="8"
            >
              Stark
            </text>
            <text
              id="usiljsvn89"
              transform="matrix(1 0 0 1 172 43)"
              font-size="12"
            >
              Stephenson
            </text>
            <text
              id="usiljsvn90"
              transform="matrix(1 0 0 1 189 267)"
              font-size="13"
            >
              Tazewell
            </text>
            <text
              id="usiljsvn91"
              transform="matrix(1 0 0 1 232 635)"
              font-size="11"
            >
              Union
            </text>
            <text
              id="usiljsvn92"
              transform="matrix(1 0 0 1 373 322)"
              font-size="13"
            >
              Vermilion
            </text>
            <text
              id="usiljsvn93"
              transform="matrix(1 0 0 1 381 511)"
              font-size="7"
            >
              Wabash
            </text>
            <text
              id="usiljsvn94"
              transform="matrix(1 0 0 1 89 218)"
              font-size="11"
            >
              Warren
            </text>
            <text
              id="usiljsvn95"
              transform="matrix(1 0 0 1 203 526)"
              font-size="10"
            >
              Washington
            </text>
            <text
              id="usiljsvn96"
              transform="matrix(1 0 0 1 312 517)"
              font-size="11"
            >
              Wayne
            </text>
            <text
              id="usiljsvn97"
              transform="matrix(1 0 0 1 342 556)"
              font-size="10"
            >
              White
            </text>
            <text
              id="usiljsvn98"
              transform="matrix(1 0 0 1 150 114)"
              font-size="12"
            >
              Whiteside
            </text>
            <text
              id="usiljsvn99"
              transform="matrix(1 0 0 1 361 155)"
              font-size="15"
            >
              Will
            </text>
            <text
              id="usiljsvn100"
              transform="matrix(1 0 0 1 247 608)"
              font-size="13"
            >
              Williamson
            </text>
            <text
              id="usiljsvn101"
              transform="matrix(1 0 0 1 216 30)"
              font-size="14"
            >
              Winnebago
            </text>
            <text
              id="usiljsvn102"
              transform="matrix(1 0 0 1 222 226)"
              font-size="12"
            >
              Woodford
            </text>
          </g>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { EventBus } from "@/event-bus";
import { usiljsconfig } from "@/assets/data/usiljsconfig";
export default {
  methods: {
    getCountyData(data) {
      //console.log("Map click: ", data.hover);
      this.$store.dispatch("setSelectedCountyData", data);
      EventBus.$emit("mapClick", data);
      this.$ga.event({
        eventCategory: "Site Map",
        eventAction: "Click",
        eventLabel: data.hover
      });
    }
  },
  props: {
    maxWidth: {
      type: Number,
      default: 500
    }
  },
  data() {
    return {
      countyData: {}
    };
  },
  computed: {
    mapData() {
      return usiljsconfig;
    }
  },
  mounted() {
    const vm = this;

    function isTouchEnabled() {
      return (
        "ontouchstart" in window ||
        navigator.MaxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0
      );
    }
    jQuery(function() {
      jQuery("path[id^=usiljs]").each(function(i, e) {
        usiladdEvent(jQuery(e).attr("id"));
      });
    });
    function usiladdEvent(id, relationId) {
      var _obj = jQuery("#" + id);
      var arr = id.split("");
      var _Textobj = jQuery(
        "#" + id + "," + "#usiljsvn" + arr.slice(6).join("")
      );
      jQuery("#" + ["visnames"]).attr({
        fill: usiljsconfig.general.visibleNames
      });
      _obj.attr({
        fill: usiljsconfig[id].upColor,
        stroke: usiljsconfig.general.borderColor
      });
      _Textobj.attr({ cursor: "default" });
      if (usiljsconfig[id].active === true) {
        _Textobj.attr({ cursor: "pointer" });
        _Textobj.hover(
          function() {
            jQuery("#usiljstip")
              .show()
              .html(usiljsconfig[id].hover);
            _obj.css({ fill: usiljsconfig[id].overColor });
          },
          function() {
            jQuery("#usiljstip").hide();
            jQuery("#" + id).css({ fill: usiljsconfig[id].upColor });
          }
        );
        if (usiljsconfig[id].target !== "none") {
          _Textobj.mousedown(function() {
            jQuery("#" + id).css({ fill: usiljsconfig[id].downColor });
          });
        }
        _Textobj.mouseup(function() {
          jQuery("#" + id).css({ fill: usiljsconfig[id].overColor });
          if (usiljsconfig[id].target === "new_window") {
            window.open(usiljsconfig[id].url);
          } else if (usiljsconfig[id].target === "same_window") {
            window.parent.location.href = usiljsconfig[id].url;
          } else if (usiljsconfig[id].target === "modal") {
            jQuery(usiljsconfig[id].url).modal("show");
          } else if (usiljsconfig[id].target === "vue") {
            //vm.countyData = usiljsconfig[id];
            vm.getCountyData(usiljsconfig[id]);
            // console.log(usiljsconfig[id])
          }
        });
        _Textobj.mousemove(function(e) {
          var x = e.pageX + 20,
            y = e.pageY - 75;
          var tipw = jQuery("#usiljstip").outerWidth(),
            tiph = jQuery("#usiljstip").outerHeight(),
            x =
              x + tipw > jQuery(document).scrollLeft() + jQuery(window).width()
                ? x - tipw - 20 * 2
                : x;
          y =
            y + tiph > jQuery(document).scrollTop() + jQuery(window).height()
              ? jQuery(document).scrollTop() +
                jQuery(window).height() -
                tiph -
                10
              : y;

          jQuery("#usiljstip").css({ left: x, top: y });
        });
        if (isTouchEnabled()) {
          _Textobj.on("touchstart", function(e) {
            var touch = e.originalEvent.touches[0];
            var x = touch.pageX + 10,
              y = touch.pageY + 15;
            var tipw = jQuery("#usiljstip").outerWidth(),
              tiph = jQuery("#usiljstip").outerHeight(),
              x =
                x + tipw >
                jQuery(document).scrollLeft() + jQuery(window).width()
                  ? x - tipw - 20 * 2
                  : x;
            y =
              y + tiph > jQuery(document).scrollTop() + jQuery(window).height()
                ? jQuery(document).scrollTop() +
                  jQuery(window).height() -
                  tiph -
                  10
                : y;
            jQuery("#" + id).css({ fill: usiljsconfig[id].downColor });
            jQuery("#usiljstip")
              .show()
              .html(usiljsconfig[id].hover);
            jQuery("#usiljstip").css({ left: x, top: y });
          });
          _Textobj.on("touchend", function() {
            jQuery("#" + id).css({ fill: usiljsconfig[id].upColor });
            if (usiljsconfig[id].target === "new_window") {
              window.open(usiljsconfig[id].url);
            } else if (usiljsconfig[id].target === "same_window") {
              window.parent.location.href = usiljsconfig[id].url;
            } else if (usiljsconfig[id].target === "modal") {
              jQuery(usiljsconfig[id].url).modal("show");
            } else if (usiljsconfig[id].target === "vue") {
              // console.log(usiljsconfig[id])
            }
          });
        }
      }
    }
  }
};
</script>

<style scoped></style>
